module.exports = __webpack_public_path__ + "img/bwc_logo.d6141ed0.png";